import type { BattleSnapshot } from '../../core';

export const HUD_LAYOUT = Object.freeze({
  p1Panel: { x: 48, y: 18, width: 430, height: 74 },
  p1Name: { x: 94, y: 27 },
  p1Badge: { x: 58, y: 26 },
  p1Hp: { x: 58, y: 56, width: 410, height: 24 },
  timerPanel: { x: 585, y: 18, width: 110, height: 56 },
  timer: { x: 640, y: 46 },
  p2Panel: { x: 802, y: 18, width: 430, height: 74 },
  p2Name: { x: 1186, y: 27 },
  p2Badge: { x: 1222, y: 26 },
  p2Hp: { x: 812, y: 56, width: 410, height: 24 },
  p1GaugePanel: { x: 48, y: 654, width: 430, height: 38 },
  p1GaugeLabel: { x: 58, y: 663 },
  p1Gauge: { x: 120, y: 663, width: 348, height: 20 },
  p2GaugePanel: { x: 802, y: 654, width: 430, height: 38 },
  p2GaugeLabel: { x: 1222, y: 663 },
  p2Gauge: { x: 812, y: 663, width: 348, height: 20 },
});

export interface HudModel {
  readonly hpRatios: readonly [number, number];
  readonly gauges: readonly [number, number];
  readonly timerSeconds: number;
}

export const createHudModel = (snapshot: BattleSnapshot): HudModel => Object.freeze({
  hpRatios: Object.freeze(snapshot.characters.map((character) => Math.max(0, Math.min(1, character.hp / character.maxHp))) as unknown as [number, number]),
  gauges: Object.freeze(snapshot.characters.map((character) => Math.max(0, Math.min(100, character.gauge))) as unknown as [number, number]),
  timerSeconds: Math.ceil(snapshot.timerFrames / 60),
});
